import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

// Sort order toggle: ASC / DESC. Shared between the Transaction Information
// tab and the Activity Information tab so both filter strips render an
// identical inline label + small Select (mock parity).
const SortOrderToggle = ({ label, value, onChange }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      marginRight: 16,
      marginLeft: 8
    }}>
    <span style={{ fontSize: 11, color: '#748aa1', whiteSpace: 'nowrap' }}>
      {label}
    </span>
    <Select
      size="small"
      value={value}
      onChange={onChange}
      style={{ width: 90, fontSize: 11 }}
      options={[
        { label: 'Newest', value: 'DESC' },
        { label: 'Oldest', value: 'ASC' }
      ]}
    />
  </div>
);

SortOrderToggle.defaultProps = {
  label: 'Sort Transaction Date:'
};

SortOrderToggle.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};

export default SortOrderToggle;
